// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".tcbmYoDD{flex-shrink:0}.UgZZroSW{-o-object-fit:cover;object-fit:cover;-o-object-position:top;object-position:top}.UgZZroSW,.ocSFYTh0{height:100%;width:100%}.ocSFYTh0{align-items:center;display:flex;justify-content:center;-webkit-user-select:none;-moz-user-select:none;user-select:none}.ocSFYTh0>span{color:#000;font-weight:600;opacity:.5}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"xs": "667.98",
	"sm": "947.98",
	"md": "1023.98",
	"lg": "1229.98",
	"container": "tcbmYoDD",
	"img": "UgZZroSW",
	"initials": "ocSFYTh0"
};
module.exports = ___CSS_LOADER_EXPORT___;
